import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/updateSource';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Update a source's name / enabled state (connection details are immutable).
function* operation(action) {
  const { sourceId, body } = action.payload;
  try {
    const res = yield call(
      axios.put,
      `${config.API_URL}/ingestion/sources/${sourceId}`,
      body,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
